import { keyBy } from 'lodash'
import { Integer } from '~/common/types'
import { useErrorModal, useSuccessToast } from '~/design_system'
import { useMsg } from '~/common/localizationUtils'
import { SOWWorkflowData, SOWWorkflowSummary } from './types'

export const withPagination = (response: any, limit: Integer | undefined) => ({
  results: response.results,
  next_params: response.next_params,
  previous_params: response.previous_params,
  totalResults: response.count,
  totalPages: limit ? Math.ceil(response.count / limit) : 1,
  totalCount: response?.total_count ?? response?.count ?? 0,
  page: limit ? Math.ceil((response.offset + limit) / limit) : 1
})

export const useBasicResponseHandler = (successMessage = 'common.ui.success') => {
  // Works in conjunction with Standard Api Exceptions for APIs
  const successToast = useSuccessToast()
  const msg = useMsg()
  const { showModal: showErrorModal } = useErrorModal()
  return {
    onSuccess: () => successToast(msg(successMessage)),
    // @ts-ignore
    onError: async error => {
      await showErrorModal({
        error,
        title: error.body.title,
        message: error.body.message
      })
    }
  }
}

export function sowUrl(sowId: number, versionId: number): string {
  return `/api/v2/sow-module/sow/${sowId}/version/${versionId}`
}

export const makeWorkflowSummary = <T extends Record<string, string>>(
  workflows: SOWWorkflowData[] | undefined,
  workflowEnum: T
): SOWWorkflowSummary<T> => {
  const workflowsByName = keyBy(workflows, 'name')
  return (Object.values(workflowEnum) as string[]).reduce((acc, name) => {
    const workflow = workflowsByName[name]
    acc[name as T[keyof T]] = {
      name,
      limited_to_fields: workflow ? workflow.limited_to_fields : [],
      enabled: !!workflow
    }
    return acc
  }, {} as SOWWorkflowSummary<T>)
}
